import { useState } from "react";
import { Mail } from "lucide-react";
import { LOGO_URL, EMAIL, SERVICES, scrollToId } from "@/data/content";
import { PolicyModal } from "@/components/PolicyModal";

const Footer = () => {
  const [policy, setPolicy] = useState(null);

  return (
  <footer className="bg-[#0F172A] pt-16 pb-8">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="inline-block rounded-2xl bg-white p-3">
            <img src={LOGO_URL} alt="Clario — Cleaner Solution" className="h-14 w-auto" />
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Soluzioni di pulizia e sanificazione professionale su tutto il territorio nazionale.
            Un unico standard, un unico referente, ovunque in Italia.
          </p>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-emergency-email"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#00B36B]/10 px-5 py-3 text-sm font-bold text-[#00B36B] transition-colors hover:bg-[#00B36B] hover:text-white"
          >
            <Mail className="h-4 w-4" />
            Urgenze e pronto intervento: {EMAIL}
          </a>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Servizi</h4>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <button
                  data-testid={`footer-link-${s.id}`}
                  onClick={() => scrollToId("servizi")}
                  className="text-sm text-slate-400 transition-colors hover:text-[#00B36B]"
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Contatti</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li>
              <a href={`mailto:${EMAIL}`} className="transition-colors hover:text-[#00B36B]">
                {EMAIL}
              </a>
            </li>
            <li>Rispondiamo entro 24 ore lavorative</li>
            <li>Copertura nazionale, 20 regioni</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center">
        <p className="text-xs text-slate-500">
          © 2026 Clario srl · Tutti i diritti riservati
        </p>
        <div className="flex gap-6 text-xs text-slate-500">
          <button
            data-testid="footer-privacy-link"
            onClick={() => setPolicy("privacy")}
            className="transition-colors hover:text-[#00B36B]"
          >
            Informativa Privacy
          </button>
          <button
            data-testid="footer-cookie-link"
            onClick={() => setPolicy("cookie")}
            className="transition-colors hover:text-[#00B36B]"
          >
            Cookie Policy
          </button>
        </div>
      </div>
      <PolicyModal open={policy} onClose={() => setPolicy(null)} />
    </div>
  </footer>
  );
};

export default Footer;
